__turbopack_context__.v({
  "blinkTwice": "VideoPlayer-module-scss-module__G_PNxG__blinkTwice",
  "collapseWindow": "VideoPlayer-module-scss-module__G_PNxG__collapseWindow",
  "expandFromTopLeft": "VideoPlayer-module-scss-module__G_PNxG__expandFromTopLeft",
  "expandWindow": "VideoPlayer-module-scss-module__G_PNxG__expandWindow",
  "media": "VideoPlayer-module-scss-module__G_PNxG__media",
  "mediaContainer": "VideoPlayer-module-scss-module__G_PNxG__mediaContainer",
  "navigation-back": "VideoPlayer-module-scss-module__G_PNxG__navigation-back",
  "navigation-next": "VideoPlayer-module-scss-module__G_PNxG__navigation-next",
  "playButton": "VideoPlayer-module-scss-module__G_PNxG__playButton",
  "scrubber": "VideoPlayer-module-scss-module__G_PNxG__scrubber",
  "scrubberHandle": "VideoPlayer-module-scss-module__G_PNxG__scrubberHandle",
  "scrubberProgress": "VideoPlayer-module-scss-module__G_PNxG__scrubberProgress",
  "scrubberWrapper": "VideoPlayer-module-scss-module__G_PNxG__scrubberWrapper",
  "shrinkToTopLeft": "VideoPlayer-module-scss-module__G_PNxG__shrinkToTopLeft",
  "timeDisplay": "VideoPlayer-module-scss-module__G_PNxG__timeDisplay",
  "title": "VideoPlayer-module-scss-module__G_PNxG__title",
  "videoPlayer": "VideoPlayer-module-scss-module__G_PNxG__videoPlayer",
  "videoPlayerControls": "VideoPlayer-module-scss-module__G_PNxG__videoPlayerControls",
  "videoPlayerWrapper": "VideoPlayer-module-scss-module__G_PNxG__videoPlayerWrapper",
  "volumeControl": "VideoPlayer-module-scss-module__G_PNxG__volumeControl",
});
